import { Badge } from '#client/components/ui/Badge';
import type { Column } from '#client/components/ui/DataTable';
import { ResourceListPage } from '#client/components/ui/ResourceListPage';
import { formatMoney, formatTat } from '#client/lib/format';
import type { LabTest } from '#shared/types';
import { RESOURCE } from '#client/lib/routes';

const columns: Column<LabTest>[] = [
  { key: 'name', header: 'Name', render: (row) => <strong>{row.name}</strong> },
  { key: 'code', header: 'Code', render: (row) => row.code, width: '140px' },
  {
    key: 'parameters',
    header: 'Parameters',
    render: (row) => <Badge tone="neutral">{row.parameters.length}</Badge>,
    align: 'center',
    width: '120px',
  },
  {
    key: 'turnaround_hours',
    header: 'Turnaround',
    render: (row) => formatTat(row.turnaround_hours),
  },
  {
    key: 'price',
    header: 'Price',
    render: (row) => formatMoney(row.price),
    align: 'end',
    width: '140px',
  },
];

export function LabTestListPage() {
  return (
    <ResourceListPage<LabTest>
      title="Lab tests"
      subtitle="Tests that can be ordered during patient registration"
      path={RESOURCE.labTests}
      columns={columns}
      noun="lab test"
      nounPlural="lab tests"
      searchPlaceholder="Search by name or code"
      rowLabel={(row) => row.name}
      createCapability="labTest.create"
      editCapability="labTest.edit"
      deleteCapability="labTest.delete"
    />
  );
}
